"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemType = void 0;
var ItemType;
(function (ItemType) {
    ItemType["Item"] = "item";
    ItemType["ItemScheduled"] = "item-scheduled";
    ItemType["ItemLive"] = "item-live";
    ItemType["ItemLiveFinalize"] = "item-live-finalize";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
//# sourceMappingURL=item-type.js.map